(function (angular) {
    'use strict';

    angular
        .module('Toyota.Directives')
        .directive('tyProvidePricingSendToDealerAnalytics', ['PricingSendToDealerAutofill', function (PricingSendToDealerAutofill) {

            function controller() {
                var tyProvidePricingSendToDealerAnalytics = this;

                tyProvidePricingSendToDealerAnalytics.getDetails = function () {
                    var localstorageAutofillData = PricingSendToDealerAutofill.get();
                    return localstorageAutofillData ? localstorageAutofillData.analyticsDetails : null;
                };
            }

            return {
                restrict: 'A',
                controller: controller,
                controllerAs: 'tyProvidePricingSendToDealerAnalytics'
            };
        }]);
})(window.angular);
